module.exports = "/assets/data/e51c47f1a3cec95fc979da1fceec49fd-SO17.data.json";